module.exports = __webpack_public_path__ + "media/images/icon-period-progress@3x-3044b3b59f54cd04026698b15691306d.png";